// extracted by mini-css-extract-plugin
export default {"container":"AssignTablesDialogActions_container__tPgFN","cancelButton":"AssignTablesDialogActions_cancelButton__JqS5W","submitButton":"AssignTablesDialogActions_submitButton__XGmtf"};